import { useQuery } from "react-query";
import queryFn from "ApiLayer/queryBuildingFootprints";
import { useAccessToken } from "hooks/useAccessToken";
import { QUERY_STALE_TIME } from "utils/constants";

export const buildingFootprintsQueryKey = ["buildingFootprints"];

export const useBuildingFootprintsQuery = (address?: Address, grossFloorArea?: number, floorsAboveGrade?: number) => {
    const accessToken = useAccessToken();

    return useQuery({
        queryKey: [...buildingFootprintsQueryKey, address],
        queryFn: async () => queryFn(accessToken, address!, grossFloorArea!, floorsAboveGrade!),
        staleTime: QUERY_STALE_TIME,
        enabled: !!address, // only request when address is defined
        // Note, remove next line if rendering issues. Used for dev purposes
        refetchOnWindowFocus: false,
    });
};
